import apiClient from './apiConfig';

// Ghi chú trong ngày ở trang Sổ thuê acc. Mỗi ngày (YYYY-MM-DD, giờ VN) 1 bản ghi.
export const dailyNotesApi = {
  // → { date, content, updatedAt }; ngày chưa có ghi chú thì content = ""
  get: async (date) => {
    const response = await apiClient.get(`/daily-notes/${date}`);
    return response.data;
  },

  save: async (date, content) => {
    const response = await apiClient.put(`/daily-notes/${date}`, { content });
    return response.data;
  },

  // Lưu nốt lúc đóng tab/chuyển tab: sendBeacon đi kèm vòng đời trang nên
  // không bị hủy như fetch/axios thường. Chỉ gửi được POST → BE nhận cả POST.
  // Trả về false nếu trình duyệt không nhận beacon, để nơi gọi lưu cách khác.
  saveBeacon: (date, content) => {
    if (typeof navigator === 'undefined' || !navigator.sendBeacon) return false;
    const url = `${apiClient.defaults.baseURL}/daily-notes/${date}`;
    const blob = new Blob([JSON.stringify({ content })], { type: 'application/json' });
    try {
      return navigator.sendBeacon(url, blob);
    } catch {
      return false;
    }
  },
};

export default dailyNotesApi;
